import React from 'react'
import { useTableContext } from '../context'
import Row, { EmptyRow } from './Row'

const Page = () => {
    const {
        page,
        rows,
        prepareRow
    } = useTableContext()

    return (
        <>
            {!rows.length && <EmptyRow />}
            {page.map(row => {
                prepareRow(row)
                return <Row row={row} {...row.getRowProps()} />
            })}
        </>
    )
}

export default Page